var _global_window_location, _global_window, _Constants_manifest2_extra_expoClient, _Constants_manifest2_extra, _Constants_manifest2, _Constants_manifest2_extra_expoClient1, _Constants_manifest2_extra1, _Constants_manifest21, _Constants_manifest2_extra_expoClient2, _Constants_manifest2_extra2, _Constants_manifest22, _Constants_expoConfig, _Constants_manifest23;
import * as Application from "expo-application";
import Constants from "expo-constants";
import * as Updates from "expo-updates";
import { Platform } from "react-native";
import semverCompare from "semver-compare";
import Url from "url-parse";
export function getNativeBuildVersionAsSemver() {
    var version = Platform.select({
        android: function() {
            return Application.nativeApplicationVersion;
        },
        web: function() {
            var _Constants_expoConfig;
            var _Constants_expoConfig_version;
            return (_Constants_expoConfig_version = (_Constants_expoConfig = Constants.expoConfig) === null || _Constants_expoConfig === void 0 ? void 0 : _Constants_expoConfig.version) !== null && _Constants_expoConfig_version !== void 0 ? _Constants_expoConfig_version : '99.99.99';
        },
        default: function() {
            return Application.nativeApplicationVersion;
        }
    })();
    if (!version) {
        throw new Error('Missing native build version');
    }
    return version;
}
export var isHermes = function() {
    return !!global.HermesInternal;
};
export var Environment = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "development";
    Environment["PRODUCTION"] = "production";
    Environment["STAGING"] = "staging";
    return Environment;
}({});
var _global_window_location_protocol;
export var manifest = process.env.NEXT_PUBLIC_API_CLIENT ? {
    name: process.env.NEXT_PUBLIC_API_CLIENT,
    slug: process.env.NEXT_PUBLIC_API_CLIENT,
    version: process.env.VERSION,
    // location can be null in some nextjs jest tests
    scheme: (_global_window_location_protocol = (_global_window = global.window) === null || _global_window === void 0 ? void 0 : (_global_window_location = _global_window.location) === null || _global_window_location === void 0 ? void 0 : _global_window_location.protocol) !== null && _global_window_location_protocol !== void 0 ? _global_window_location_protocol : 'https'
} : Constants.expoConfig ? {
    name: Constants.expoConfig.name || 'Aviva',
    slug: Constants.expoConfig.slug,
    version: getNativeBuildVersionAsSemver(),
    scheme: Constants.expoConfig.scheme
} : {
    name: ((_Constants_manifest2 = Constants.manifest2) === null || _Constants_manifest2 === void 0 ? void 0 : (_Constants_manifest2_extra = _Constants_manifest2.extra) === null || _Constants_manifest2_extra === void 0 ? void 0 : (_Constants_manifest2_extra_expoClient = _Constants_manifest2_extra.expoClient) === null || _Constants_manifest2_extra_expoClient === void 0 ? void 0 : _Constants_manifest2_extra_expoClient.name) || 'Aviva',
    slug: ((_Constants_manifest21 = Constants.manifest2) === null || _Constants_manifest21 === void 0 ? void 0 : (_Constants_manifest2_extra1 = _Constants_manifest21.extra) === null || _Constants_manifest2_extra1 === void 0 ? void 0 : (_Constants_manifest2_extra_expoClient1 = _Constants_manifest2_extra1.expoClient) === null || _Constants_manifest2_extra_expoClient1 === void 0 ? void 0 : _Constants_manifest2_extra_expoClient1.slug) || 'oui-aviva',
    version: getNativeBuildVersionAsSemver(),
    scheme: (_Constants_manifest22 = Constants.manifest2) === null || _Constants_manifest22 === void 0 ? void 0 : (_Constants_manifest2_extra2 = _Constants_manifest22.extra) === null || _Constants_manifest2_extra2 === void 0 ? void 0 : (_Constants_manifest2_extra_expoClient2 = _Constants_manifest2_extra2.expoClient) === null || _Constants_manifest2_extra_expoClient2 === void 0 ? void 0 : _Constants_manifest2_extra_expoClient2.scheme
};
export var APP_SLUG = manifest.slug;
export var IS_STAFF_APP = APP_SLUG === 'oui-aviva-staff';
var releaseChannel = Updates.channel || 'development';
export var environment = Platform.select({
    // CAPS hosts in prod on more TLDs than 'health' so it's easier to match on 'dev'
    web: function() {
        var _global_window_env, _global_window;
        if (typeof window === 'undefined') {
            if (process.env['NEXT_PUBLIC_ENV']) {
                return process.env['NEXT_PUBLIC_ENV'];
            }
            return "development";
        }
        // @ts-expect-error defined by web-core/getDynamicEnv
        if ((_global_window = global.window) === null || _global_window === void 0 ? void 0 : (_global_window_env = _global_window.env) === null || _global_window_env === void 0 ? void 0 : _global_window_env['NEXT_PUBLIC_ENV']) {
            var _global_window_env1, _global_window1;
            // @ts-expect-error defined by web-core/getDynamicEnv
            return (_global_window1 = global.window) === null || _global_window1 === void 0 ? void 0 : (_global_window_env1 = _global_window1.env) === null || _global_window_env1 === void 0 ? void 0 : _global_window_env1['NEXT_PUBLIC_ENV'];
        }
        return window.location.hostname === 'localhost' ? "development" : window.location.host.split('.').reverse()[0] === 'dev' || // For firebase hosting preview channels
        window.location.hostname.includes('-dev-') || window.location.hostname.endsWith('.chromatic.com') ? "staging" : "production";
    },
    default: function() {
        var applicationId = Application.applicationId;
        if ((applicationId === null || applicationId === void 0 ? void 0 : applicationId.endsWith('.debug')) || process.env.NODE_ENV === 'test' || [
            'development'
        ].includes(releaseChannel)) {
            return "development";
        } else if ((applicationId === null || applicationId === void 0 ? void 0 : applicationId.endsWith('.staging')) || [
            'test',
            'staging'
        ].includes(releaseChannel)) {
            return "staging";
        }
        return "production";
    }
})();
export var IS_PRODUCTION = environment === "production";
export var ENABLE_TTS = false;
export var CLINICIAN_WIZARD_STEPS = 6;
var _Constants_expoConfig_extra, _ref;
var Config = (_ref = (_Constants_expoConfig_extra = (_Constants_expoConfig = Constants.expoConfig) === null || _Constants_expoConfig === void 0 ? void 0 : _Constants_expoConfig.extra) !== null && _Constants_expoConfig_extra !== void 0 ? _Constants_expoConfig_extra : (_Constants_manifest23 = Constants.manifest2) === null || _Constants_manifest23 === void 0 ? void 0 : _Constants_manifest23.extra) !== null && _ref !== void 0 ? _ref : {};
function getConfigValue(key) {
    var _global_window_env, _global_window, _process_env, _process;
    var nextKey = "NEXT_PUBLIC_".concat(key);
    // @ts-expect-error window.env is defined in nextjs layout
    var value = Config[key] || ((_global_window = global.window) === null || _global_window === void 0 ? void 0 : (_global_window_env = _global_window.env) === null || _global_window_env === void 0 ? void 0 : _global_window_env[nextKey]) || ((_process = process) === null || _process === void 0 ? void 0 : (_process_env = _process.env) === null || _process_env === void 0 ? void 0 : _process_env[nextKey]);
    if (typeof value !== 'string' && process.env.NODE_ENV !== 'test') {
        // NEXTJS and storybook builds don't have Config set, and also don't rely on these values so it's safe
        // not to warn
        if (!process.env.NEXT_PUBLIC_API_CLIENT && !process.env.STORYBOOK_CLIENT) {
            console.log(new Error("Config object not properly initialized in build: missing ".concat(key)));
        }
        return '';
    }
    return value;
}
export var API_URL = getConfigValue('API_URL');
export var REST_API_URL = getConfigValue('REST_API_URL');
export var BOT_TRANSITION_URL = getConfigValue('BOT_TRANSITION_URL');
export var CLOUD_FUNCTION_URL = getConfigValue('CLOUD_FUNCTION_URL');
export var AMPLITUDE_API_KEY = getConfigValue('AMPLITUDE_API_KEY');
var AMPLITUDE_URL_OBJ = new Url(API_URL || 'https://oui.dev');
AMPLITUDE_URL_OBJ.set('hostname', AMPLITUDE_URL_OBJ.hostname.split('.').slice(-2, AMPLITUDE_URL_OBJ.hostname.split('.').length).join('.'));
AMPLITUDE_URL_OBJ.pathname = '/pupil';
export var AMPLITUDE_URL = AMPLITUDE_URL_OBJ.toString();
export var SENTRY_DSN = getConfigValue('SENTRY_DSN');
export var MUX_ENV_KEY = getConfigValue('MUX_ENV_KEY');
export var remoteConfigDefaults = {
    apiUrl: API_URL,
    subscriptionUri: getConfigValue('SUBSCRIPTION_API_URL'),
    restApiUrl: getConfigValue('REST_API_URL')
};
export var REGEX = {
    email: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i,
    // https://www.regextester.com/17
    phone: /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/
};
export var SESSION_TIMEOUT = environment === "development" ? 40 * 60000 : manifest.slug === 'oui-aviva' ? 3 * 60000 : 15 * 60000;
// use a non-round number to more easily distiguish this timeout from other 10s timeouts
export var LOADING_TIMEOUT = 10001;
export var DETOX_SIGNATURE = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAA0NDQ0ODQ8REQ8VFxQXFR8dGhodHy8iJCIkIi9HLTQtLTQtRz9MPjo+TD9xWU9PWXGDbmhug5+Ojp/Ivsj///8BDQ0NDQ4NDxERDxUXFBcVHx0aGh0fLyIkIiQiL0ctNC0tNC1HP0w+Oj5MP3FZT09ZcYNuaG6Dn46On8i+yP/////CABEIAKoBLAMBIgACEQEDEQH/xAAbAAEBAAMBAQEAAAAAAAAAAAAABAIDBQYBB//aAAgBAQAAAAD9OAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB84ej0WQAAAAAhtQdAAAAAAQ3I7AAAAABHYlqAAAAAHP6DVjvAAAAAPP8AoCSsAAAAA43ZJagAAAACG4iryDDXvAAAAByesTad1IAAAAGmDdjXuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAgBAhAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH//xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf//EADoQAAIBAgMCCQcNAAAAAAAAAAECAwQRAAVBElAQFCAhMVJxgbETIlFTgpGhFSQzNEBicHWAo7LC0v/aAAgBAQABPwD9CjEKDc2AFycR0j5mPLVcswhJvDAjlAE0LkWJY4npnyRuN00kxpF+swu5lsvrELYUqwDKQQRcEag7jzC5pzEpsZXWK/oDmxPuvhQFAsLACwGCAwIIuCLEYyy0EL0Zv83bYS/q+lNxyjylbSppGjyH+A8TwtaLMInHRLEyN2odpdxx3auq26gjj9wLf24a6ypHOBzRSo/dfZbcdDKsk2Z6FKvYPaIweGaITRSxnodGU94tilmMtNCx6gv267iyA7T53+Zv8EHIpBsNPDqkxPc/n+JO4smgERzU6nMZT8FHIF1r0Gk0du+M38DuKijkj40HQreqkZb6g2seRXqyxeWRSWgkEotqB0gdoJwjK6K6kFWAII1B5TyRxKWdgq+k4ileTaJiZUFtknmLd2g+3wyfJ1TxKWwie5pT4x9q6ciStpoG2ZJRt9RfOc+yLnAkrJuaOIQr15edu5RiOnRTtsWkk67m57tBuCeCGoieKaJJEYWZWFxg5U0agU2Y1kK6LtCQfuBjbHE64E3zWX2Y0/zhaAn6esqZhoCwjHujAxDTwwC0caoPui34o//EABQRAQAAAAAAAAAAAAAAAAAAAHD/2gAIAQIBAT8AUf/EABQRAQAAAAAAAAAAAAAAAAAAAHD/2gAIAQMBAT8AUf/Z";
export var DEFAULT_HEADER_MODE = 'float';
export var IOS_14_OR_GREATER = Platform.OS === 'ios' && Platform.Version && semverCompare(Platform.Version.toString(), '14.0') >= 0;
export var FLAGS = {
    allowDarkTheme: false && environment === "development" && __DEV__,
    showEnvelopeIDInChat: false,
    showI18NFlags: false,
    showI18NKeys: false,
    useIOS14DatePicker: false,
    useMediaLibraryAlbums: environment !== "production"
};
